import { addSlidesTabIndex } from "./swiper/addSlidesTabIndex";

const swiperHelpers = {
  addSlidesTabIndex,
};

export default swiperHelpers;
